import { render, staticRenderFns } from "./communityConfig.vue?vue&type=template&id=219f0580&scoped=true"
import script from "./communityConfig.vue?vue&type=script&lang=js"
export * from "./communityConfig.vue?vue&type=script&lang=js"
import style0 from "./communityConfig.vue?vue&type=style&index=0&id=219f0580&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f0580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('219f0580')) {
      api.createRecord('219f0580', component.options)
    } else {
      api.reload('219f0580', component.options)
    }
    module.hot.accept("./communityConfig.vue?vue&type=template&id=219f0580&scoped=true", function () {
      api.rerender('219f0580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectConfig/components/communityConfig.vue"
export default component.exports